import { WorkOrderProductsState } from "./work-order-products.interface";

export const createWorkOrderProductsState = (): WorkOrderProductsState => ({
  errors: null,
  loading: false,
  products: [],
});
